module.exports = __webpack_public_path__ + "img/pending.20ed9e77.png";